import { render, staticRenderFns } from "./WorkflowFormBuilderRevisionGrantAccessFormDialog.vue?vue&type=template&id=4c207fb8&"
import script from "./WorkflowFormBuilderRevisionGrantAccessFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderRevisionGrantAccessFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports